export const NumberInput = {
  baseStyle: {
    width: '100%',
    height: '100%',

    backgroundColor: 'input.background',
    field: {
      padding: '10px 16px',
      textColor: 'input.text',
      outlineOffset: '0',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'input.border',
      borderRadius: '9999px',
      backgroundColor: 'input.background',
      _placeholder: { color: 'input.placeholder' },
    },
  },
  sizes: {
    md: {
      field: {
        height: 'auto',
        minHeight: 'auto',
      },
    },
    withLeftIcon: {
      padding: '10px 40px',
      field: {
        padding: '10px 40px',
      },
    },
  },
  variants: {
    primary: {
      field: {
        _hover: {
          boxShadow: 'none',
          borderColor: 'input.borderHover',
          borderWidth: '2px',
          margin: '-1px',
        },
        _focus: {
          boxShadow: 'none',
          borderWidth: '2px',
          borderColor: 'brand.accent',
          margin: '-1px',
        },
      },
    },
    error: {
      field: {
        borderWidth: '2px',
        borderColor: 'brand.error',
        margin: '-1px',
        _hover: {
          boxShadow: 'none',
          borderColor: 'brand.error',
          borderWidth: '2px',
          margin: '-1px',
        },
        _focus: {
          boxShadow: 'none',
          borderWidth: '2px',
          borderColor: 'brand.error',
          margin: '-1px',
        },
      },
    },
  },
  defaultProps: {
    variant: 'primary',
    size: 'md',
  },
}
